var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarningInvoiceCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.66699V2.83366M3.5 1.66699V2.83366",
    stroke: "#616975",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99477 8.08301H7.00002M6.99477 10.4163H7.00002M9.32548 8.08301H9.33073M4.66406 8.08301H4.6693M4.66406 10.4163H4.6693",
    stroke: "#616975",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03906 5.16699H11.9557",
    stroke: "#616975",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.46094 7.64187C1.46094 5.10013 1.46094 3.82925 2.19134 3.03962C2.92174 2.25 4.09731 2.25 6.44844 2.25H7.55677C9.9079 2.25 11.0835 2.25 11.8139 3.03962C12.5443 3.82925 12.5443 5.10013 12.5443 7.64187V7.94147C12.5443 10.4832 12.5443 11.7541 11.8139 12.5437C11.0835 13.3333 9.9079 13.3333 7.55677 13.3333H6.44844C4.09731 13.3333 2.92174 13.3333 2.19134 12.5437C1.46094 11.7541 1.46094 10.4832 1.46094 7.94147V7.64187Z",
    stroke: "#616975",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 5.16699H12.25",
    stroke: "#616975",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningInvoiceCalender);
export default __webpack_public_path__ + "static/media/earning-invoice-calender.7161772ee7c716efd1edd61aa095dfce.svg";
export { ForwardRef as ReactComponent };